export default __webpack_public_path__ + "static/media/icons8-python.88c1e5ae.svg";